"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _createStarExport(obj) { Object.keys(obj) .filter((key) => key !== "default" && key !== "__esModule") .forEach((key) => { if (exports.hasOwnProperty(key)) { return; } Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]}); }); }// src/index.ts
var _HttpClient = require('./core/HttpClient'); var _HttpClient2 = _interopRequireDefault(_HttpClient); _createStarExport(_HttpClient);

var src_default = new (0, _HttpClient2.default)();



exports.HttpClient = _HttpClient2.default; exports.default = src_default;
